<div class="fixed transform z-2" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-0 pb-0">
  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten">
      <div class="btn"><a>PI Trends</a></div>
    </div>
  </div>

</div>
<div>
  <div class="card">
    <p-tabView (onChange)="switchHeaders($event);">
      <p-tabPanel header="Root Cause">
        <div class="flex justify-content-between align-items-center title-bg ">
          <h1 class="title">
            Root Cause Trends
          </h1>
        </div>
        <p-table #dt [value]="rootCauseTrendsList" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines" responsiveLayout="scroll" [rowHover]="true"
              sortMode="multiple" [customSort]="true" (sortFunction)="customSort($event)" [resizableColumns]="true" columnResizeMode="expand">  
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="rootgrp">Root Cause Type<p-sortIcon field="rootgrp"></p-sortIcon></th>
              <th pSortableColumn="rootcause">Root Cause<p-sortIcon field="rootcause"></p-sortIcon></th>
              <th pSortableColumn="rootcausecount">Root Cause Count<p-sortIcon field="rootcausecount"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rootCauseTrendsList>
            <tr>
              <td>{{rootCauseTrendsList.rootgrp}}</td>
              <td>{{rootCauseTrendsList.rootcause}}</td>
              <td>{{rootCauseTrendsList.rootcausecount}}</td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <h5 *ngIf="totalRecordsRootCauseTrends==0" class="text-center create-roles">
                <b> No records found</b>
              </h5>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="Case Review">
        <div class="flex justify-content-between align-items-center title-bg ">
          <h1 class="title">
            Case Review Process Trends
          </h1>
        </div>
        <p-table #dtt [value]=" caseReviewTrendsList" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines" responsiveLayout="scroll" [rowHover]="true"
        sortMode="multiple" [customSort]="true" (sortFunction)="customSort($event)" [resizableColumns]="true" columnResizeMode="expand">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="Title">Performance Metric Outliers<p-sortIcon field="Title"></p-sortIcon></th>
              <th pSortableColumn="Total">Number of Times<p-sortIcon field="Total"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-caseReviewTrendsList>
            <tr>
              <td>{{caseReviewTrendsList.Title}}</td>
              <td>{{caseReviewTrendsList.Total}}</td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <h5 *ngIf="totalRecordsCaseReviewTrends==0" class="text-center create-roles">
                <b> No records found</b>
              </h5>
            </tr>
          </ng-template>
        </p-table>

      </p-tabPanel>
    </p-tabView>
    <div class="md:col-12">
      <span class="tableRefreshTime">
        Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}}
      </span>
    </div>
  </div>
</div>
